import { defineStore } from "pinia"
import type { Alert } from "@/types/alert"

export const useSystemFeedback = defineStore("systemFeedback", {
  state: () => {
    return {
      feedback: {
        type: "success",
        title: "",
        text: "",
        timeout: 0
      } as Alert,
      timeout: {} as NodeJS.Timeout
    }
  },

  actions: {
    setFeedback(feedback: Alert, time = 5000) {
      this.resetFeedback()
      setTimeout(() => {
        if (time > 0) {
          this.feedback = { ...feedback, timeout: time / 1000 }
          this.timeout = setTimeout(() => {
            this.$reset()
          }, time)
        } else {
          this.feedback = feedback
        }
      }, 1)
    },

    resetFeedback() {
      clearTimeout(this.timeout)
      this.$reset()
    }
  }
})
